export enum SlotPosition {
  right= 'right',
  left= 'left'
}
